import {
  coreExtensionData,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import { userSettingsMessages } from './translations';

/**
 * Configurações in the v2 design (Story 5.5, AC-17): the page and its three
 * tabs keep their extensions, routes and the stock state; only the loaders
 * of the tab contents are replaced. Page and tab titles are set in
 * app-config.yaml.
 */
export const byxUserSettingsPlugin = userSettingsPlugin.withOverrides({
  extensions: [
    userSettingsPlugin.getExtension('sub-page:user-settings/general').override({
      factory: originalFactory =>
        originalFactory({
          params: {
            loader: async () => {
              const { ByxSettingsGeneral } = await import(
                './ByxSettingsGeneral'
              );
              return <ByxSettingsGeneral />;
            },
          },
        }),
    }),
    userSettingsPlugin
      .getExtension('sub-page:user-settings/auth-providers')
      .override({
        factory: (originalFactory, { inputs }) =>
          originalFactory({
            params: {
              loader: async () => {
                const { ByxSettingsAuthProviders } = await import(
                  './ByxSettingsGeneral'
                );
                return (
                  <ByxSettingsAuthProviders
                    providerSettings={inputs.providerSettings?.get(
                      coreExtensionData.reactElement,
                    )}
                  />
                );
              },
            },
          }),
      }),
    userSettingsPlugin
      .getExtension('sub-page:user-settings/feature-flags')
      .override({
        factory: originalFactory =>
          originalFactory({
            params: {
              loader: async () => {
                const { ByxSettingsFeatureFlags } = await import(
                  './ByxSettingsGeneral'
                );
                return <ByxSettingsFeatureFlags />;
              },
            },
          }),
      }),
  ],
});

/**
 * pt-BR texts of Configurações (Story 2.3). The app's translations input
 * only accepts extensions of the app plugin itself.
 */
export const settingsTranslationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [userSettingsMessages],
});
